import React from "react";
import "./Founder.css";

import founderImage from "../../uploads/fidin img pdf_page-0001.jpg";

const Founder = () => {
  return (
    <div className="founder-page">

      {/* HERO SECTION */}

      <div className="founder-header">
        <h1>Meet Our Founder</h1>
        <p>The Vision Behind Fidin Construction</p>
      </div>

      <div className="founder-container">


        {/* FOUNDERS */}

        <div className="founder-main">

          {/* Founder 1 */}

          <div className="founder-img">
            <img src={founderImage} alt="Founder" />
          </div>

          <div className="founder-info">
            <h2>Shweta Nerurkar</h2>

            <p className="title">
              Founder & Chief Executive Officer
            </p>

            <p>
              An experienced professional in renewable energy and
              infrastructure development, with expertise in:
            </p>

            <ul>
              <li>Solar power project execution</li>
              <li>Transmission line and substation projects</li>
              <li>EPC project management</li>
            </ul>

            <p>
              <strong>
                As the founder of FIDIN, Shweta brings a heartfelt
                belief in seeing every project through to its
                completion. She is a guiding force, embodying
                integrity, compassion, and a dedication to helping
                others.
              </strong>
            </p>
          </div>

          {/* Founder 2 */}

          <div className="founder-info">
            <h2>Khyati Nerurkar</h2>

            <p className="title">
              Co-Founder & Marketing Head
            </p>

            <p>
              Khyati, co-founder and Marketing Head, brings a
              creative vision from her background in filmmaking.
            </p>

            <p>
              <strong>
                She is passionate about expanding her skills in
                marketing, bringing fresh perspectives as FIDIN
                grows. She is dedicated to learning and evolving
                alongside the company.
              </strong>
            </p>
          </div>

        </div>

        {/* APPROACH */}

        <div className="section">
          <h3>⭐ OUR APPROACH</h3>

          <p>
            <strong>1. Project Planning & Feasibility</strong>
            {" "}Detailed technical and financial assessment.
          </p>

          <p>
            <strong>2. Engineering & Design</strong>
            {" "}Optimized and compliant system design.
          </p>

          <p>
            <strong>3. Procurement</strong>
            {" "}Reliable sourcing with quality assurance.
          </p>

          <p>
            <strong>4. Execution</strong>
            {" "}Efficient on-site implementation.
          </p>

          <p>
            <strong>5. Testing & Commissioning</strong>
            {" "}Ensuring performance and compliance.
          </p>
        </div>

        {/* HSE */}

        <div className="section">
          <h3>⭐ HEALTH, SAFETY & QUALITY (HSE)</h3>

          <h4>
            At FIDIN Ventures, safety and quality are integral to
            every project
          </h4>

          <p><strong>• Strict adherence to safety standards</strong></p>
          <p><strong>• Regular site safety audits</strong></p>
          <p><strong>• Quality assurance at every stage</strong></p>
          <p><strong>• Compliance with regulatory requirements</strong></p>
        </div>

        {/* ACHIEVEMENTS */}

        <div className="section">
          <h3>Achievements</h3>

          <div className="achievements">

            <div className="achievement-box">
              <h4>200+</h4>
              <p>Projects Completed</p>
            </div>

            <div className="achievement-box">
              <h4>15+</h4>
              <p>Years Experience</p>
            </div>

            <div className="achievement-box">
              <h4>50+</h4>
              <p>Team Members</p>
            </div>

            <div className="achievement-box">
              <h4>50+</h4>
              <p>Happy Clients</p>
            </div>

          </div>
        </div>

        {/* SUSTAINABILITY */}

        <div className="section">
          <h3>⭐ SUSTAINABILITY COMMITMENT</h3>

          <h4>
            We are committed to building environmentally responsible infrastructure
          </h4>

          <p><strong>• Promoting renewable energy adoption</strong></p>
          <p><strong>• Reducing carbon footprint through efficient design</strong></p>
          <p><strong>• Sustainable construction practices</strong></p>
          <p><strong>• Long-term asset performance focus</strong></p>
        </div>

        {/* CLIENTS */}

        <div className="section">
          <h3>⭐ CLIENTS & PARTNERS</h3>

          <h4>Trusted by Industry Stakeholders</h4>

          <div className="client-grid">

            <div className="client-box">Client Logo 1</div>
            <div className="client-box">Client Logo 2</div>
            <div className="client-box">Client Logo 3</div>
            <div className="client-box">Client Logo 4</div>
            <div className="client-box">Client Logo 5</div>
            <div className="client-box">Client Logo 6</div>

          </div>

          <p><strong>• Government & Utility Companies</strong></p>
          <p><strong>• Infrastructure Developers</strong></p>
          <p><strong>• Industrial Clients</strong></p>
          <p><strong>• EPC Partners</strong></p>
        </div>

        {/* CERTIFICATES */}

        <div className="section">
          <h3>⭐ CERTIFICATIONS & REGISTRATIONS</h3>

          <div className="certificate-grid">

            <div className="certificate-box">
              <div className="certificate-placeholder">
                MSME Certificate
              </div>
              <p>MSME Registered</p>
            </div>

            <div className="certificate-box">
              <div className="certificate-placeholder">
                GST Certificate
              </div>
              <p>GST Registered</p>
            </div>

            <div className="certificate-box">
              <div className="certificate-placeholder">
                ISO Certificate
              </div>
              <p>ISO Certification</p>
            </div>

            <div className="certificate-box">
              <div className="certificate-placeholder">
                Safety Certificate
              </div>
              <p>Safety & Compliance</p>
            </div>

          </div>
        </div>

        {/* CONTACT */}

        <div className="contact-founder">
          <h3>Connect With Our Founder</h3>

          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noreferrer"
            className="btn-linkedin"
          >
            LinkedIn Profile
          </a>

          <a
            href="mailto:info@fidinconstruction.com"
            className="btn-email"
          >
            Send Email
          </a>
        </div>

      </div>
    </div>
  );
};

export default Founder;